import { useLocation, useNavigate } from '@tanstack/react-router';

import { type NavigationAdapter } from '../context';

export const useTanStackRouterAdapter = (): NavigationAdapter => {
  const location = useLocation();
  const navigate = useNavigate();

  return {
    currentPathname: location.publicHref,
    navigate: {
      push: (path: string) => {
        navigate({ to: path });
      },
    },
  };
};
